import React, { Fragment } from 'react';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import bingematesPrivacy from '../../api/bingemates-privacy';

const BingeMatesPrivacyPage = () => {
    return (
        <Fragment>
            <div className="body_wrap sco_agency">
                <section className="page-title cp-page-title pt-120 pos-rel">
                    <div className="container">
                        <div className="page-title-wrap">
                            <div className="row mt-none-30 align-items-center">
                                <div className="col-lg-10 mt-30">
                                    <div className="page-title-box">
                                        <h2 className="title">{bingematesPrivacy.pageTitle}</h2>
                                        <p>{bingematesPrivacy.pageSubtitle}</p>
                                        <span className="page-update_time">Last Updated: {bingematesPrivacy.lastUpdated}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="terms&conditions-section cp-det-bg">
                    <div className="container">
                        <div className="terms-section_inner pt-80 pb-75">
                            <div className="row">
                                <div className="col-lg-11">

                                    {/* 1. Introduction */}
                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">{bingematesPrivacy.introduction.title}</h2>
                                        <p>{bingematesPrivacy.introduction.content}</p>
                                    </div>

                                    {/* 2. Data We Collect */}
                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">{bingematesPrivacy.dataWeCollect.title}</h2>
                                        <p>{bingematesPrivacy.dataWeCollect.description}</p>

                                        <h3 className="item_details_info_title" style={{ fontSize: '20px', marginTop: '20px' }}>
                                            {bingematesPrivacy.dataWeCollect.userProvided.title}
                                        </h3>
                                        <ul className="privacy-details">
                                            {bingematesPrivacy.dataWeCollect.userProvided.items.map((item, index) => (
                                                <li key={index}>{item}</li>
                                            ))}
                                        </ul>

                                        <h3 className="item_details_info_title" style={{ fontSize: '20px', marginTop: '20px' }}>
                                            {bingematesPrivacy.dataWeCollect.automaticallyCollected.title}
                                        </h3>
                                        <ul className="privacy-details">
                                            {bingematesPrivacy.dataWeCollect.automaticallyCollected.items.map((item, index) => (
                                                <li key={index}>{item}</li>
                                            ))}
                                        </ul>

                                        <h3 className="item_details_info_title" style={{ fontSize: '20px', marginTop: '20px' }}>
                                            {bingematesPrivacy.dataWeCollect.dataWeDoNotCollect.title}
                                        </h3>
                                        <ul className="privacy-details">
                                            {bingematesPrivacy.dataWeCollect.dataWeDoNotCollect.items.map((item, index) => (
                                                <li key={index}>{item}</li>
                                            ))}
                                        </ul>
                                    </div>

                                    {/* 3. How We Use Data */}
                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">{bingematesPrivacy.howWeUseData.title}</h2>
                                        <p>{bingematesPrivacy.howWeUseData.description}</p>
                                        <ul className="privacy-details">
                                            {bingematesPrivacy.howWeUseData.items.map((item, index) => (
                                                <li key={index}>{item}</li>
                                            ))}
                                        </ul>
                                    </div>

                                    {/* 4. Data Storage and Retention */}
                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">{bingematesPrivacy.dataStorageAndRetention.title}</h2>
                                        <ul className="privacy-details">
                                            {bingematesPrivacy.dataStorageAndRetention.items.map((item, index) => (
                                                <li key={index}>{item}</li>
                                            ))}
                                        </ul>
                                    </div>

                                    {/* 5. Data Sharing */}
                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">{bingematesPrivacy.dataSharing.title}</h2>
                                        <p><strong>{bingematesPrivacy.dataSharing.doNot.description}</strong></p>
                                        <ul className="privacy-details">
                                            {bingematesPrivacy.dataSharing.doNot.items.map((item, index) => (
                                                <li key={index}>{item}</li>
                                            ))}
                                        </ul>
                                        <p style={{ marginTop: '15px' }}><strong>{bingematesPrivacy.dataSharing.mayShare.description}</strong></p>
                                        <ul className="privacy-details">
                                            {bingematesPrivacy.dataSharing.mayShare.items.map((item, index) => (
                                                <li key={index}>{item}</li>
                                            ))}
                                        </ul>
                                    </div>

                                    {/* 6. Third-Party Services */}
                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">{bingematesPrivacy.thirdPartyServices.title}</h2>
                                        <p>We use:</p>
                                        <ul className="privacy-details">
                                            {bingematesPrivacy.thirdPartyServices.services.map((service, index) => (
                                                <li key={index}><strong>{service.name}</strong> — {service.purpose}</li>
                                            ))}
                                        </ul>
                                        <p style={{ marginTop: '10px' }}>{bingematesPrivacy.thirdPartyServices.description}</p>
                                    </div>

                                    {/* 7. Security */}
                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">{bingematesPrivacy.security.title}</h2>
                                        <p>{bingematesPrivacy.security.description}</p>
                                        <ul className="privacy-details">
                                            {bingematesPrivacy.security.items.map((item, index) => (
                                                <li key={index}>{item}</li>
                                            ))}
                                        </ul>
                                    </div>

                                    {/* 8. Your Rights */}
                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">{bingematesPrivacy.yourRights.title}</h2>
                                        <p>{bingematesPrivacy.yourRights.description}</p>
                                        <ul className="privacy-details">
                                            {bingematesPrivacy.yourRights.items.map((item, index) => (
                                                <li key={index}>{item}</li>
                                            ))}
                                        </ul>
                                    </div>

                                    {/* 9. Children's Privacy */}
                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">{bingematesPrivacy.childrensPrivacy.title}</h2>
                                        <p>{bingematesPrivacy.childrensPrivacy.content}</p>
                                    </div>

                                    {/* 10. International Users */}
                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">{bingematesPrivacy.internationalUsers.title}</h2>
                                        <p>{bingematesPrivacy.internationalUsers.content}</p>
                                    </div>

                                    {/* 11. Changes to This Policy */}
                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">{bingematesPrivacy.changesToPolicy.title}</h2>
                                        <p>{bingematesPrivacy.changesToPolicy.content}</p>
                                    </div>

                                    {/* 12. Contact Us */}
                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">{bingematesPrivacy.contactUs.title}</h2>
                                        <p>{bingematesPrivacy.contactUs.content}</p>
                                        <p>Email: <a href={`mailto:${bingematesPrivacy.contactUs.email}`}>{bingematesPrivacy.contactUs.email}</a></p>
                                    </div>

                                    {/* 13. GDPR Compliance */}
                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">{bingematesPrivacy.gdprCompliance.title}</h2>
                                        <p>{bingematesPrivacy.gdprCompliance.description}</p>
                                        <ul className="privacy-details">
                                            {bingematesPrivacy.gdprCompliance.items.map((item, index) => (
                                                <li key={index}>{item}</li>
                                            ))}
                                        </ul>
                                    </div>

                                    {/* 14. Do Not Track */}
                                    <div className="item-details-widget">
                                        <h2 className="item_details_info_title">{bingematesPrivacy.doNotTrack.title}</h2>
                                        <p>{bingematesPrivacy.doNotTrack.content}</p>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer />
            <Scrollbar />
        </Fragment>
    );
};

export default BingeMatesPrivacyPage;
